export default [
  { name: 'Brazil', displayName: 'Brasil', disabled: false },
  { name: 'United Kingdom', displayName: 'Reino Unido', disabled: false },
  { name: 'United States', displayName: 'Estados Unidos', disabled: false },
  { name: 'Australia', displayName: 'Austrália', disabled: false },
  { name: 'Canada', displayName: 'Canadá', disabled: false },
  { name: 'France', displayName: 'França', disabled: false },
  { name: 'Germany', displayName: 'Alemanha', disabled: false },
  { name: 'Spain', displayName: 'Espanha', disabled: false },
  { name: 'China', displayName: 'China', disabled: false },
  { name: null, displayName: '---', disabled: true },
  { name: 'Afghanistan', displayName: 'Afeganistão', disabled: false },
  { name: 'Åland Islands', displayName: 'Åland Islands', disabled: false },
  { name: 'Albania', displayName: 'Albânia', disabled: false },
  { name: 'Algeria', displayName: 'Argélia', disabled: false },
  { name: 'American Samoa', displayName: 'American Samoa', disabled: false },
  { name: 'Andorra', displayName: 'Andorra', disabled: false },
  { name: 'Angola', displayName: 'Angola', disabled: false },
  { name: 'Anguilla', displayName: 'Anguilla', disabled: false },
  { name: 'Antarctica', displayName: 'Antarctica', disabled: false },
  {
    name: 'Antigua & Barbuda',
    displayName: 'Antigua & Barbuda',
    disabled: false,
  },
  { name: 'Argentina', displayName: 'Argentina', disabled: false },
  { name: 'Armenia', displayName: 'Armênia', disabled: false },
  { name: 'Aruba', displayName: 'Aruba', disabled: false },
  {
    name: 'Ascension Island',
    displayName: 'Ascension Island',
    disabled: false,
  },
  { name: 'Austria', displayName: 'Áustria', disabled: false },
  { name: 'Azerbaijan', displayName: 'Azerbaijão', disabled: false },
  { name: 'Bahamas', displayName: 'Bahamas', disabled: false },
  { name: 'Bahrain', displayName: 'Barém', disabled: false },
  { name: 'Bangladesh', displayName: 'Bangladesh', disabled: false },
  { name: 'Barbados', displayName: 'Barbados', disabled: false },
  { name: 'Belarus', displayName: 'Bielorrússia', disabled: false },
  { name: 'Belgium', displayName: 'Bélgica', disabled: false },
  { name: 'Belize', displayName: 'Belize', disabled: false },
  { name: 'Benin', displayName: 'Benim', disabled: false },
  { name: 'Bermuda', displayName: 'Bermuda', disabled: false },
  { name: 'Bhutan', displayName: 'Butão', disabled: false },
  { name: 'Bolivia', displayName: 'Bolívia', disabled: false },
  {
    name: 'Bosnia & Herzegovina',
    displayName: 'Bosnia & Herzegovina',
    disabled: false,
  },
  { name: 'Botswana', displayName: 'Botsuana', disabled: false },
  {
    name: 'British Indian Ocean Territory',
    displayName: 'British Indian Ocean Territory',
    disabled: false,
  },
  {
    name: 'British Virgin Islands',
    displayName: 'British Virgin Islands',
    disabled: false,
  },
  { name: 'Brunei', displayName: 'Brunei', disabled: false },
  { name: 'Bulgaria', displayName: 'Bulgária', disabled: false },
  { name: 'Burkina Faso', displayName: 'Burkina Faso', disabled: false },
  { name: 'Burundi', displayName: 'Burundi', disabled: false },
  { name: 'Cambodia', displayName: 'Camboja', disabled: false },
  { name: 'Cameroon', displayName: 'Camarões', disabled: false },
  { name: 'Canary Islands', displayName: 'Canary Islands', disabled: false },
  { name: 'Cape Verde', displayName: 'Cabo Verde', disabled: false },
  {
    name: 'Caribbean Netherlands',
    displayName: 'Caribbean Netherlands',
    disabled: false,
  },
  { name: 'Cayman Islands', displayName: 'Cayman Islands', disabled: false },
  {
    name: 'Central African Republic',
    displayName: 'República Central Africana',
    disabled: false,
  },
  { name: 'Ceuta & Melilla', displayName: 'Ceuta & Melilla', disabled: false },
  { name: 'Chad', displayName: 'Chade', disabled: false },
  { name: 'Chile', displayName: 'Chile', disabled: false },
  {
    name: 'Christmas Island',
    displayName: 'Christmas Island',
    disabled: false,
  },
  {
    name: 'Cocos (Keeling) Islands',
    displayName: 'Cocos (Keeling) Islands',
    disabled: false,
  },
  { name: 'Colombia', displayName: 'Colômbia', disabled: false },
  { name: 'Comoros', displayName: 'Comores', disabled: false },
  {
    name: 'Congo - Brazzaville',
    displayName: 'Congo - Brazzaville',
    disabled: false,
  },
  {
    name: 'Congo - Kinshasa',
    displayName: 'Congo - Kinshasa',
    disabled: false,
  },
  { name: 'Cook Islands', displayName: 'Cook Islands', disabled: false },
  { name: 'Costa Rica', displayName: 'Costa Rica', disabled: false },
  { name: 'Côte d’Ivoire', displayName: 'Côte d’Ivoire', disabled: false },
  { name: 'Croatia', displayName: 'Croácia', disabled: false },
  { name: 'Cuba', displayName: 'Cuba', disabled: false },
  { name: 'Curaçao', displayName: 'Curaçao', disabled: false },
  { name: 'Cyprus', displayName: 'Chipre', disabled: false },
  { name: 'Czech Republic', displayName: 'República Tcheca', disabled: false },
  { name: 'Denmark', displayName: 'Dinamarca', disabled: false },
  { name: 'Diego Garcia', displayName: 'Diego Garcia', disabled: false },
  { name: 'Djibouti', displayName: 'Djibouti', disabled: false },
  {
    name: 'Dominica',
    displayName: 'Domínica',
    disabled: false,
  },
  {
    name: 'Dominican Republic',
    displayName: 'República Dominicana',
    disabled: false,
  },
  { name: 'Ecuador', displayName: 'Ecuador', disabled: false },
  { name: 'Egypt', displayName: 'Egito', disabled: false },
  { name: 'El Salvador', displayName: 'El Salvador', disabled: false },
  {
    name: 'Equatorial Guinea',
    displayName: 'Guiné Equatorial',
    disabled: false,
  },
  { name: 'Eritrea', displayName: 'Eritreia', disabled: false },
  { name: 'Estonia', displayName: 'Estônia', disabled: false },
  { name: 'Ethiopia', displayName: 'Etiópia', disabled: false },
  {
    name: 'Falkland Islands',
    displayName: 'Falkland Islands',
    disabled: false,
  },
  { name: 'Faroe Islands', displayName: 'Faroe Islands', disabled: false },
  { name: 'Fiji', displayName: 'Fiji', disabled: false },
  { name: 'Finland', displayName: 'Finlândia', disabled: false },
  { name: 'French Guiana', displayName: 'French Guiana', disabled: false },
  {
    name: 'French Polynesia',
    displayName: 'French Polynesia',
    disabled: false,
  },
  {
    name: 'French Southern Territories',
    displayName: 'French Southern Territories',
    disabled: false,
  },
  { name: 'Gabon', displayName: 'Gabão', disabled: false },
  { name: 'Gambia', displayName: 'Gâmbia', disabled: false },
  { name: 'Georgia', displayName: 'Geórgia', disabled: false },
  { name: 'Ghana', displayName: 'Gana', disabled: false },
  { name: 'Gibraltar', displayName: 'Gibraltar', disabled: false },
  { name: 'Greece', displayName: 'Grécia', disabled: false },
  { name: 'Greenland', displayName: 'Greenland', disabled: false },
  { name: 'Grenada', displayName: 'Grenada', disabled: false },
  { name: 'Guadeloupe', displayName: 'Guadeloupe', disabled: false },
  { name: 'Guam', displayName: 'Guam', disabled: false },
  { name: 'Guatemala', displayName: 'Guatemala', disabled: false },
  { name: 'Guernsey', displayName: 'Guernsey', disabled: false },
  { name: 'Guinea', displayName: 'Guiné', disabled: false },
  { name: 'Guinea-Bissau', displayName: 'Guiné Bissau', disabled: false },
  { name: 'Guyana', displayName: 'Guiana', disabled: false },
  { name: 'Haiti', displayName: 'Haiti', disabled: false },
  { name: 'Honduras', displayName: 'Honduras', disabled: false },
  { name: 'Hong Kong', displayName: 'Hong Kong', disabled: false },
  { name: 'Hungary', displayName: 'Hungria', disabled: false },
  { name: 'Iceland', displayName: 'Islândia', disabled: false },
  { name: 'India', displayName: 'Índia', disabled: false },
  { name: 'Indonesia', displayName: 'Indonésia', disabled: false },
  { name: 'Iran', displayName: 'Irã', disabled: false },
  { name: 'Iraq', displayName: 'Iraque', disabled: false },
  { name: 'Ireland', displayName: 'Irlanda', disabled: false },
  { name: 'Isle of Man', displayName: 'Isle of Man', disabled: false },
  { name: 'Israel', displayName: 'Israel', disabled: false },
  { name: 'Italy', displayName: 'Itália', disabled: false },
  { name: 'Jamaica', displayName: 'Jamaica', disabled: false },
  { name: 'Japan', displayName: 'Japão', disabled: false },
  { name: 'Jersey', displayName: 'Jersey', disabled: false },
  { name: 'Jordan', displayName: 'Jordânia', disabled: false },
  { name: 'Kazakhstan', displayName: 'Cazaquistão', disabled: false },
  { name: 'Kenya', displayName: 'Quênia', disabled: false },
  { name: 'Kiribati', displayName: 'Kiribati', disabled: false },
  { name: 'Kosovo', displayName: 'Kosovo', disabled: false },
  { name: 'Kuwait', displayName: 'Kuwait', disabled: false },
  { name: 'Kyrgyzstan', displayName: 'Quirguistão', disabled: false },
  { name: 'Laos', displayName: 'Laos', disabled: false },
  { name: 'Latvia', displayName: 'Letônia', disabled: false },
  { name: 'Lebanon', displayName: 'Líbano', disabled: false },
  { name: 'Lesotho', displayName: 'Lesoto', disabled: false },
  { name: 'Liberia', displayName: 'Libéria', disabled: false },
  { name: 'Libya', displayName: 'Líbia', disabled: false },
  { name: 'Liechtenstein', displayName: 'Liechtenstein', disabled: false },
  { name: 'Lithuania', displayName: 'Lituânia', disabled: false },
  { name: 'Luxembourg', displayName: 'Luxemburgo', disabled: false },
  { name: 'Macau SAR China', displayName: 'Macau SAR China', disabled: false },
  { name: 'Macedonia', displayName: 'Macedônia', disabled: false },
  { name: 'Madagascar', displayName: 'Madagáscar', disabled: false },
  { name: 'Malawi', displayName: 'Malavi', disabled: false },
  { name: 'Malaysia', displayName: 'Malásia', disabled: false },
  { name: 'Maldives', displayName: 'Malásia', disabled: false },
  { name: 'Mali', displayName: 'Mali', disabled: false },
  { name: 'Malta', displayName: 'Malta', disabled: false },
  {
    name: 'Marshall Islands',
    displayName: 'Ilhas Marshall',
    disabled: false,
  },
  { name: 'Martinique', displayName: 'Martinique', disabled: false },
  { name: 'Mauritania', displayName: 'Mauritânia', disabled: false },
  { name: 'Mauritius', displayName: 'Maurício', disabled: false },
  { name: 'Mayotte', displayName: 'Mayotte', disabled: false },
  { name: 'Mexico', displayName: 'México', disabled: false },
  { name: 'Micronesia', displayName: 'Micronésia', disabled: false },
  { name: 'Moldova', displayName: 'Moldávia', disabled: false },
  { name: 'Monaco', displayName: 'Mônaco', disabled: false },
  { name: 'Mongolia', displayName: 'Mongólia', disabled: false },
  { name: 'Montenegro', displayName: 'Montenegro', disabled: false },
  { name: 'Montserrat', displayName: 'Montserrat', disabled: false },
  { name: 'Morocco', displayName: 'Marrocos', disabled: false },
  { name: 'Mozambique', displayName: 'Moçambique', disabled: false },
  { name: 'Myanmar (Burma)', displayName: 'Myanmar (Burma)', disabled: false },
  { name: 'Namibia', displayName: 'Namíbia', disabled: false },
  { name: 'Nauru', displayName: 'Nauru', disabled: false },
  { name: 'Nepal', displayName: 'Nepal', disabled: false },
  {
    name: 'Netherlands',
    displayName: 'Países Baixos (Holanda)',
    disabled: false,
  },
  { name: 'New Caledonia', displayName: 'New Caledonia', disabled: false },
  { name: 'New Zealand', displayName: 'Nova Zelândia', disabled: false },
  { name: 'Nicaragua', displayName: 'Nicarágua', disabled: false },
  { name: 'Niger', displayName: 'Níger', disabled: false },
  { name: 'Nigeria', displayName: 'Nigéria', disabled: false },
  { name: 'Niue', displayName: 'Niue', disabled: false },
  { name: 'Norfolk Island', displayName: 'Norfolk Island', disabled: false },
  { name: 'North Korea', displayName: 'Coreia do Norte', disabled: false },
  {
    name: 'Northern Mariana Islands',
    displayName: 'Northern Mariana Islands',
    disabled: false,
  },
  { name: 'Norway', displayName: 'Noruega', disabled: false },
  { name: 'Oman', displayName: 'Omã', disabled: false },
  { name: 'Pakistan', displayName: 'Paquistão', disabled: false },
  { name: 'Palau', displayName: 'Palau', disabled: false },
  {
    name: 'Palestinian Territories',
    displayName: 'Territórios Palestinos',
    disabled: false,
  },
  { name: 'Panama', displayName: 'Panamá', disabled: false },
  {
    name: 'Papua New Guinea',
    displayName: 'Papua-Nova Guiné',
    disabled: false,
  },
  { name: 'Paraguay', displayName: 'Paraguai', disabled: false },
  { name: 'Peru', displayName: 'Peru', disabled: false },
  { name: 'Philippines', displayName: 'Filipinas', disabled: false },
  {
    name: 'Pitcairn Islands',
    displayName: 'Pitcairn Islands',
    disabled: false,
  },
  { name: 'Poland', displayName: 'Polônia', disabled: false },
  { name: 'Portugal', displayName: 'Portugal', disabled: false },
  { name: 'Puerto Rico', displayName: 'Puerto Rico', disabled: false },
  { name: 'Qatar', displayName: 'Catar', disabled: false },
  { name: 'Réunion', displayName: 'Réunion', disabled: false },
  { name: 'Romania', displayName: 'Romênia', disabled: false },
  { name: 'Russia', displayName: 'Rússia', disabled: false },
  { name: 'Rwanda', displayName: 'Ruanda', disabled: false },
  { name: 'Samoa', displayName: 'Samoa', disabled: false },
  { name: 'San Marino', displayName: 'São Marino', disabled: false },
  {
    name: 'São Tomé & Príncipe',
    displayName: 'São Tomé & Príncipe',
    disabled: false,
  },
  { name: 'Saudi Arabia', displayName: 'Arábia Saudita', disabled: false },
  { name: 'Senegal', displayName: 'Senegal', disabled: false },
  { name: 'Serbia', displayName: 'Sérvia', disabled: false },
  { name: 'Seychelles', displayName: 'Seicheles', disabled: false },
  { name: 'Sierra Leone', displayName: 'Sierra Leone', disabled: false },
  { name: 'Singapore', displayName: 'Cingapura', disabled: false },
  { name: 'Sint Maarten', displayName: 'Sint Maarten', disabled: false },
  { name: 'Slovakia', displayName: 'Eslováquia', disabled: false },
  { name: 'Slovenia', displayName: 'Eslovênia', disabled: false },
  { name: 'Solomon Islands', displayName: 'Ilhas Salomão', disabled: false },
  { name: 'Somalia', displayName: 'Somália', disabled: false },
  { name: 'South Africa', displayName: 'África do Sul', disabled: false },
  {
    name: 'South Georgia & South Sandwich Islands',
    displayName: 'South Georgia & South Sandwich Islands',
    disabled: false,
  },
  { name: 'South Korea', displayName: 'Coréia do Sul', disabled: false },
  { name: 'South Sudan', displayName: 'South Sudan', disabled: false },
  { name: 'Sri Lanka', displayName: 'Sri Lanka', disabled: false },
  { name: 'St. Barthélemy', displayName: 'St. Barthélemy', disabled: false },
  { name: 'St. Helena', displayName: 'St. Helena', disabled: false },
  {
    name: 'St. Kitts & Nevis',
    displayName: 'St. Kitts & Nevis',
    disabled: false,
  },
  { name: 'St. Lucia', displayName: 'St. Lucia', disabled: false },
  { name: 'St. Martin', displayName: 'St. Martin', disabled: false },
  {
    name: 'St. Pierre & Miquelon',
    displayName: 'St. Pierre & Miquelon',
    disabled: false,
  },
  {
    name: 'St. Vincent & Grenadines',
    displayName: 'St. Vincent & Grenadines',
    disabled: false,
  },
  { name: 'Sudan', displayName: 'Sudão', disabled: false },
  { name: 'Suriname', displayName: 'Suriname', disabled: false },
  {
    name: 'Svalbard & Jan Mayen',
    displayName: 'Svalbard & Jan Mayen',
    disabled: false,
  },
  { name: 'Swaziland', displayName: 'Suazilândia', disabled: false },
  { name: 'Sweden', displayName: 'Suécia', disabled: false },
  { name: 'Switzerland', displayName: 'Suíça', disabled: false },
  { name: 'Syria', displayName: 'Síria', disabled: false },
  { name: 'Taiwan', displayName: 'Taiwan', disabled: false },
  { name: 'Tajikistan', displayName: 'Tajiquistão', disabled: false },
  { name: 'Tanzania', displayName: 'Tanzânia', disabled: false },
  { name: 'Thailand', displayName: 'Tailândia', disabled: false },
  { name: 'Timor-Leste', displayName: 'Timor-Leste', disabled: false },
  { name: 'Togo', displayName: 'Togo', disabled: false },
  { name: 'Tokelau', displayName: 'Tokelau', disabled: false },
  { name: 'Tonga', displayName: 'Tonga', disabled: false },
  {
    name: 'Trinidad & Tobago',
    displayName: 'Trinidad & Tobago',
    disabled: false,
  },
  {
    name: 'Tristan da Cunha',
    displayName: 'Tristan da Cunha',
    disabled: false,
  },
  { name: 'Tunisia', displayName: 'Tunísia', disabled: false },
  { name: 'Turkey', displayName: 'Turquia', disabled: false },
  { name: 'Turkmenistan', displayName: 'Turcomenistão', disabled: false },
  {
    name: 'Turks & Caicos Islands',
    displayName: 'Turks & Caicos Islands',
    disabled: false,
  },
  { name: 'Tuvalu', displayName: 'Tuvalu', disabled: false },
  {
    name: 'U.S. Outlying Islands',
    displayName: 'U.S. Outlying Islands',
    disabled: false,
  },
  {
    name: 'U.S. Virgin Islands',
    displayName: 'U.S. Virgin Islands',
    disabled: false,
  },
  { name: 'Uganda', displayName: 'Uganda', disabled: false },
  { name: 'Ukraine', displayName: 'Ukraine', disabled: false },
  {
    name: 'United Arab Emirates',
    displayName: 'Emirados Árabes Unidos',
    disabled: false,
  },
  { name: 'Uruguay', displayName: 'Uruguai', disabled: false },
  { name: 'Uzbekistan', displayName: 'Uzbequistão', disabled: false },
  { name: 'Vanuatu', displayName: 'Vanuatu', disabled: false },
  { name: 'Vatican City', displayName: 'Vatican City', disabled: false },
  { name: 'Venezuela', displayName: 'Venezuela', disabled: false },
  { name: 'Vietnam', displayName: 'Vietnã', disabled: false },
  { name: 'Wallis & Futuna', displayName: 'Wallis & Futuna', disabled: false },
  { name: 'Western Sahara', displayName: 'Western Sahara', disabled: false },
  { name: 'Yemen', displayName: 'Iêmen', disabled: false },
  { name: 'Zambia', displayName: 'Zâmbia', disabled: false },
  { name: 'Zimbabwe', displayName: 'Zimbábue', disabled: false },
];
